<template>
  <div class="admin animatedBox">
    <div class="container fluid">
      <div class="card p-1">
        <fd-table
          :componentTitle="'Admins'"
          :routerButton="routerButton"
          :tableButton="actionButton"
          :indexed="true"
          :plugin="{
            search: [1, 2],
          }"
          :searchBarTitle="'Search from name...'"
          :getFunction="getAllAdmin"
        ></fd-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      routerButton: [
        {
          title: "New Admin",
          class: "add",
          routerLink: "/admin/add",
        },
      ],
      actionButton: [
        {
          title: "Edit",
          class: "edit",
          routerLink: "/admin/edit",
        },
        {
          title: "Password Edit",
          class: "update",
          routerLink: "/admin/password",
        },
        {
          title: "Delete",
          class: "delete",
          routerLink: null,
          onclick: async (id) => {
            const c = confirm(
              "Are you sure to delete this admin? You cannot undo after this."
            );

            if (c) {
              return this.removeAdmin(id);
            }
          },
          getData: true,
        },
      ],
    };
  },
  methods: {
    async getAllAdmin(keyword, currentPage, perPage, isLoading) {
      const request = await this.$store.dispatch("admin/getAllAdmin", {
        keyword: keyword,
        currentPage: currentPage,
        perPage: perPage,
        isLoading: isLoading,
      });

      return request;
    },
    async removeAdmin(id) {
      const request = await this.$store.dispatch("admin/deleteAdmin", id);

      return request;
    },
  },
};
</script>

<style>
.admin {
}
</style>